export default function constructQueryString (queryObject) {
  const queryString = Object.entries(queryObject)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')

  return queryString
}
